/** Shown instead of the app when `/config.json` is missing or invalid — the host's deployment is broken, not the user's input. */
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card.js';

export type ConfigErrorProps = { readonly message: string };

export function ConfigError({ message }: ConfigErrorProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background p-6">
      <Card className="w-full max-w-lg border-destructive" data-testid="config-error">
        <CardHeader>
          <CardTitle>Norna cannot start</CardTitle>
          <CardDescription>This page was served without a usable runtime configuration (/config.json).</CardDescription>
        </CardHeader>
        <CardContent>
          <pre className="whitespace-pre-wrap rounded-md bg-muted p-3 font-mono text-xs">{message}</pre>
        </CardContent>
      </Card>
    </div>
  );
}
